import { render, staticRenderFns } from "./BlockType27.vue?vue&type=template&id=b22706de"
import script from "./BlockType27.vue?vue&type=script&lang=ts"
export * from "./BlockType27.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports